import React from 'react';
import { ShadowsSize } from 'src/components/foundations/tokens';
import { CardContainerStyled } from './CardContainer.styles';

export interface CardContainerProps {
  children: React.ReactNode;
  hasShadow?: boolean;
  $shadowSize?: ShadowsSize;
  $width?: string;
  $margin?: string;
}

export const CardContainer = ({
  children,
  hasShadow = true,
  $shadowSize = ShadowsSize.medium,
  $width = '100%',
  $margin = '0',
  ...props
}: CardContainerProps) => {
  return (
    <CardContainerStyled
      hasShadow={hasShadow}
      $shadowSize={$shadowSize}
      $width={$width}
      $margin={$margin}
      {...props}
    >
      {children}
    </CardContainerStyled>
  );
};
